<template>
  <el-dialog
    title="用户编辑"
    :visible.sync="dialogShow"
    @close="closeDialog"
    @open="openDialog"
  >
    <el-form :model="form" :rules="rules" ref="form">
      <el-form-item label="真实姓名" :label-width="formLabelWidth" prop="name">
        <el-input
          v-model="form.name"
          autocomplete="off"
          placeholder="请输入真实姓名"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="登录名称"
        :label-width="formLabelWidth"
        prop="loginName"
      >
        <el-input
          v-model="form.loginName"
          autocomplete="off"
          placeholder="请输入登录名称"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="所属角色"
        :label-width="formLabelWidth"
        prop="roleId"
      >
        <el-select v-model="form.roleId" placeholder="请选择">
          <el-option
            v-for="item in roleArray"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="saveUser">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "UserEdit",
  props: {
    show: Boolean,
    formData: Object,
    action: String,
  },
  data() {
    return {
      dialogShow: this.show,
      systemArray: [],
      roleArray: [],
      form: {
        name: "",
        loginName: "",
        systemId: "",
        roleId: "",
      },
      formLabelWidth: "120px",
      rules: {
        name: [
          { required: true, message: "请输入真实姓名", trigger: "blur" },
          { min: 2, max: 10, message: "请输入2到10个字", trigger: "blur" },
        ],
        loginName: [
          { required: true, message: "请输入登录名称", trigger: "blur" },
          { min: 6, max: 20, message: "请输入6到20个字符", trigger: "blur" },
        ],
        systemId: [
          { required: true, message: "请选择所属系统", trigger: "change" },
        ],
        roleId: [{ required: true, message: "请选择角色", trigger: "change" }],
      },
    };
  },
  methods: {
    saveUser() {
      if (this.action === "addRole") {
        let params = {
          id: this.formData.id,
          roleId: this.form.roleId,
          systemId: this.form.systemId,
        };
        this.axios.post("/sysUserInfo/addRole", params).then((res) => {
          if (res.code === 200) {
            this.$notify({
              title: "添加成功",
              message: res.msg,
              type: "success",
            });

            this.$bus.$emit("refresh"); //通知刷新

            this.closeDialog();
          } else {
            this.$notify.error({
              title: "添加失败",
              message: res.msg,
            });
          }
        });
      } else {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.axios.post("/sysUserInfo/saveUser", this.form).then((res) => {
              if (res.code === 200) {
                this.$notify({
                  title: "添加成功",
                  message: res.msg,
                  type: "success",
                });

                this.$bus.$emit("refresh"); //通知刷新

                this.closeDialog();
              } else {
                this.$notify.error({
                  title: "添加失败",
                  message: res.msg,
                });
              }
            });
          } else {
            return false;
          }
        });
      }
    },
    openDialog() {
      this.systemSelectedChange();
    },
    closeDialog() {
      this.dialogShow = false;
      this.$refs["form"].resetFields(); //关闭的时候重置表单
      this.$emit("update:show", false);
    },

    systemSelectedChange() {
      console.log(this.form.roleId);
      this.roleArray = [];
      this.axios
        .get("/sysRoleInfo/selectOption", { params: {} })
        .then((res) => {
          if (res.code === 200) {
            this.roleArray = res.data;
          }
          if (this.formData != null) {
            this.form.name = this.formData.name;
            this.form.loginName = this.formData.loginName;
            this.form.roleId = this.formData.roleId;
          } else {
            this.form.name = "";
            this.form.loginName = "";
            this.form.roleId = "";
          }
        });
    },
  },
  watch: {
    show(newVal) {
      this.dialogShow = newVal;
    },
  },
  created() {},
};
</script>

<style scoped>
</style>